import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Spin, Result, Typography } from 'antd'
import { handleOAuthCallback } from '@/providers/auth-provider'

const { Text } = Typography

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const errorParam = searchParams.get('error')

    if (errorParam) {
      setError(decodeURIComponent(errorParam))
      return
    }

    const token = searchParams.get('token')

    if (!token) {
      setError('No authentication token received')
      return
    }

    // Handle the OAuth callback - stores token in localStorage
    handleOAuthCallback(token).then((success) => {
      if (success) {
        navigate('/', { replace: true })
      } else {
        setError('Failed to authenticate. Please try again.')
      }
    })
  }, [searchParams, navigate])

  if (error) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #1e3a5f 0%, #0d9488 100%)',
          padding: 24,
        }}
      >
        <Result
          status="error"
          title="Greska pri prijavljivanju"
          subTitle={error}
          style={{
            background: 'white',
            borderRadius: 8,
            padding: 32,
            maxWidth: 500,
          }}
          extra={
            <a href="/login" style={{ color: '#1e3a5f' }}>
              Nazad na prijavu
            </a>
          }
        />
      </div>
    )
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #1e3a5f 0%, #0d9488 100%)',
        gap: 16,
      }}
    >
      <Spin size="large" />
      <Text style={{ color: 'white', fontSize: 16 }}>
        Prijavljivanje u toku...
      </Text>
    </div>
  )
}
